import { RedpacketStatus, TransferStatus } from "~proto"
import type { NoticeItem } from "./notice-center-context"

export type PendingCollectKind = "redpacket" | "transfer"

export function getPendingCollectKind(
  item: NoticeItem,
  detailData?: any,
): PendingCollectKind | null {
  if (![2, 4].includes(Number(item.type))) return null
  if (item.extra?.redpacket_id && detailData?.status === RedpacketStatus.ACTIVE) {
    return "redpacket"
  }
  if (item.extra?.order_no && detailData?.status === TransferStatus.PENDING) {
    return "transfer"
  }
  return null
}

export function isPendingCollectNotice(item: NoticeItem, detailData?: any) {
  return getPendingCollectKind(item, detailData) != null
}

export function getPendingCollectConfirmText(kind: PendingCollectKind) {
  return kind === "redpacket" ? "领取红包" : "转账确认"
}

export function getPendingCollectTitle(item: NoticeItem, kind: PendingCollectKind) {
  if (item.label?.trim()) return item.label.trim()
  return kind === "redpacket" ? "红包待领取" : "转账待确认"
}

export function getPendingCollectContent(
  item: NoticeItem,
  detailData: any,
  kind: PendingCollectKind,
) {
  if (item.content?.trim()) return item.content.trim()
  const name = detailData?.sender_nickname || "对方"
  if (kind === "transfer") {
    return `${name}向您转账¥${detailData?.amount ?? "0"}`
  }
  return `${name}发送的红包待领取`
}

function findMessageIdInChat(
  chat: { messages?: string[] },
  messageStore: { messages: Map<string, any> },
  item: NoticeItem,
  detailData?: any,
) {
  const redpacketId = item.extra?.redpacket_id ?? detailData?.redpacket_id
  const orderNo = item.extra?.order_no ?? detailData?.order_no

  for (const msgId of chat.messages ?? []) {
    const msg = messageStore.messages.get(msgId)
    if (!msg?.attach) continue
    if (
      redpacketId != null &&
      String(msg.attach.redpacket_info?.redpacket_id) === String(redpacketId)
    ) {
      return msg.message_id ?? msg.id
    }
    if (orderNo && msg.attach.trans_info?.order_no === orderNo) {
      return msg.message_id ?? msg.id
    }
  }
  return undefined
}

export function resolveNoticeChatNavigation(
  item: NoticeItem,
  detailData: any,
  chatStore: {
    getChatByMessageRef: (ref: { chat_cid?: string; chat_id?: number | string | null }) => any
    getChat: (chat_id: string | number) => any
  },
  messageStore: { messages: Map<string, any> },
): { chat_id: string; scrollToMessageId?: string | number } | null {
  const extra = item.extra ?? {}

  let scrollToMessageId =
    extra.message_id ??
    extra.msg_id ??
    detailData?.message_id ??
    detailData?.msg_id

  const chatCid = extra.chat_cid ?? detailData?.chat_cid ?? extra.chat_id ?? detailData?.chat_id
  const chatId = extra.chat_id ?? detailData?.chat_id

  let chat = chatStore.getChatByMessageRef({
    chat_cid: chatCid != null ? String(chatCid) : undefined,
    chat_id: chatId,
  })

  if (!chat && chatCid != null) {
    chat = chatStore.getChat(String(chatCid))
  }

  if (!chat) return null

  if (scrollToMessageId == null) {
    scrollToMessageId = findMessageIdInChat(chat, messageStore, item, detailData)
  }

  return {
    chat_id: chat.chat_id,
    scrollToMessageId: scrollToMessageId ?? undefined,
  }
}
